// ============================================================
// Domain — Commission tiers and their baseline / floor rules
// ============================================================

import { ExposurePackage, resolveExposurePackage } from './exposurePackage';

export interface BaselineTier {
  id: string;
  category: string;
  baseline: number;
  unit: '$' | '%';
}

export interface TierRate extends BaselineTier {
  rate: number;
  isAdded?: boolean;
  _touched?: boolean;
}

export const makeBlankTiers = (baselineTiers: BaselineTier[]): TierRate[] =>
  baselineTiers.map((t) => ({ ...t, rate: t.baseline, _touched: false }));

// Any touched, baseline-violating tier blocks Continue. Mirrors prototype
// UpsizeWizard.jsx:198 — gates submission so the merchant fixes invalid rates
// before reaching Review (rather than discovering it at submit time).
export const tiersHaveBaselineViolation = (tiers: TierRate[]): boolean =>
  tiers.some((t) => !t.isAdded && t._touched && t.baseline !== null && Number(t.rate) < Number(t.baseline));

/** True when any %-tier commission rate is below the package's minCommissionRate floor.
 *  No _touched guard — it's an absolute floor; auto-fill pre-satisfies it on selection,
 *  so this only bites when the merchant manually edits a %-tier back below the minimum. */
export const tiersBelowPackageMinimum = (
  tiers: TierRate[],
  packageRef: string | null,
  packages: ExposurePackage[],
  country?: string
): boolean => {
  const min = resolveExposurePackage(packages, packageRef, country)?.minCommissionRate || 0;
  if (min <= 0) return false;
  return tiers.some((t) => t.unit === '%' && Number(t.rate) < min);
};
